module.exports = __webpack_public_path__ + "static/Canela-Bold-80d89262ba1f2ae8d1fcf9f48d1542a6.otf";